import { useDispatch } from "react-redux";
import { showSnack } from "react-redux-snackbar";

const useShowSnack = () => {
  const dispatch = useDispatch();

  return (uniqueId: any, args: any) => {
    dispatch(showSnack(uniqueId, args));
  };
};

export default useShowSnack;
